import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const ShopTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell sortDirection={orderBy === 'preShopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'preShopName'}
            direction={order}
            onClick={() => {
              onRequestSort('preShopName');
            }}
          >
            仮店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'streetAddress' ? order : false}>
          <TableSortLabel
            active={orderBy === 'streetAddress'}
            direction={order}
            onClick={() => {
              onRequestSort('streetAddress');
            }}
          >
            住所
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'phone' ? order : false}>
          <TableSortLabel
            active={orderBy === 'phone'}
            direction={order}
            onClick={() => {
              onRequestSort('phone');
            }}
          >
            電話番号
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'status' ? order : false}>
          <TableSortLabel
            active={orderBy === 'status'}
            direction={order}
            onClick={() => {
              onRequestSort('status');
            }}
          >
            ステータス
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={order}
            onClick={() => {
              onRequestSort('createdAt');
            }}
          >
            登録日時
          </TableSortLabel>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(ShopTableHead);
